import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, forwardRef, HostBinding, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { OfferAttachment, OfferAttachmentFilters } from 'src/app/commons/models/offer-attachment.model';
import * as OfferAttachmentActions from 'src/app/store/actions/offer-attachment.actions';
import { AppState } from 'src/app/store/reducers';


export const CURRENCY_FIELD_MAT_FORM_FIELD_CONTROL: any = {
  provide: MatFormFieldControl,
  useExisting: forwardRef(() => OfferAttachmentFieldComponent),
};

@Component({
  selector: "app-offer-attachment-field",
  templateUrl: "./offer-attachment-field.component.html",
  styleUrls: ["./offer-attachment-field.component.scss"],
  providers: [CURRENCY_FIELD_MAT_FORM_FIELD_CONTROL],
  host: {
    "[class.floating]": "shouldLabelFloat",
    "[id]": "id",
  },
})
export class OfferAttachmentFieldComponent
  implements ControlValueAccessor, MatFormFieldControl<OfferAttachment> {
  private unsubscribe$ = new Subject<void>();
  private _value: OfferAttachment;
  private _disabled = false;

  private _required = false;

  get errorState(): boolean {
    return !this.ngControl.valid;
  }
  focused: boolean; //TODO
  controlType?: string = "offer-attachment-selection-field";
  autofilled?: boolean;
  offerAttachmentAriaDescribedBy?: string;


  @Input()
  offerAttachmentFilters: OfferAttachmentFilters;

  constructor(
    private actions$: Actions,
    private store$: Store<AppState>,
    @Optional() @Self() public ngControl: NgControl
  ) {

    this.actions$
      .pipe(
        ofType(OfferAttachmentActions.offerAttachmentSelected),
        takeUntil(this.unsubscribe$),
        map(({ offerAttachment }) => (offerAttachment ? new OfferAttachment(offerAttachment) : null))

      )
      .subscribe((offerAttachment) => (this.value = offerAttachment));
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }
  stateChanges = new Subject<void>();
  id: string;


  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  private _placeholder: string;

  get empty() {
    return !this.value;
  }

  @HostBinding("class.floating")
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  get required() {
    return this._required || this.ngControl?.control?.hasValidator(Validators.required) || false;
  }

  @Input()
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }

  get disabled(): boolean {
    return this._disabled;
  }

  @Input()
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  setDescribedByIds(ids: string[]): void {
    //TODO
  }
  onContainerClick(event: MouseEvent): void {
    if (!this.disabled) {
      if ((event.target as Element).tagName.toLowerCase() != "mat-icon") {
        this.selectOfferAttachment();
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.stateChanges.complete();
  }

  selectOfferAttachment() {
    this.store$.dispatch(OfferAttachmentActions.selectOfferAttachment({ filters: this.offerAttachmentFilters }));
  }

  clearOfferAttachment() {
    this.value = null;
  }

  set value(value: OfferAttachment) {
    this._value = value;
    this.notifyValueChange();
    this.stateChanges.next();
  }

  get value(): OfferAttachment {
    return this._value;
  }

  onChange: (value) => {};
  onTouched: () => {};

  notifyValueChange(): void {
    if (this.onChange) {
      this.onChange(this.value);
    }
  }

  writeValue(obj: OfferAttachment): void {
    this._value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
